import React from 'react';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const QuestionIcon = ({ toolTipText = 'Calculating Standing' }) => (
  <Icon tooltip={toolTipText} iconObj={faCircleQuestion} />
);

export default QuestionIcon;